import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PaymentRequest } from '../types/payment/payment-request';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { PaymentStatus } from '../types/payment/payment-status';
import { Pay } from '../types/payment/pay';
import { DomainEventBus, DomainEventType } from '../core/events/domain-event-bus';

@Injectable({
  providedIn: 'root'
})
export class HttpPaymentService {
  private apiUrl: string = environment.apiUrl;

  constructor(
    private client: HttpClient,
    private bus: DomainEventBus
  ) {}

  async getPaymentRequest(publicId: string): Promise<PaymentRequest> {
    const prStorageKey = `pr::${publicId}`;
    try {
      const storedPr = sessionStorage.getItem(prStorageKey);
      if (storedPr) {
        const pr = JSON.parse(storedPr) as PaymentRequest;
        this.bus.emit({ type: DomainEventType.PaymentApiGetRequestEnd, publicId, ok: true, cache: 'hit' });
        return pr;
      }
      const pr = await lastValueFrom(this.client.get<PaymentRequest>(`${this.apiUrl}/v1/public/requests/${publicId}`));
      if (pr) sessionStorage.setItem(prStorageKey, JSON.stringify(pr));
      this.bus.emit({ type: DomainEventType.PaymentApiGetRequestEnd, publicId, ok: true, cache: 'miss' });
      return pr;
    } catch (err: any) {
      this.bus.emit({ type: DomainEventType.PaymentApiGetRequestEnd, publicId, ok: false, error: { name: err?.name, message: err?.message, status: err?.status } });
      throw err;
    }
  }

  getPaymentStatus(publicId: string, reference: string): Promise<PaymentStatus> {
    const p = lastValueFrom(this.client.get<PaymentStatus>(`${this.apiUrl}/v1/public/requests/${publicId}/${reference}/status`));
    p.then(() => this.bus.emit({ type: DomainEventType.PaymentApiStatusCheckEnd, publicId, correlationId: reference, ok: true })).catch((err: any) => {
      this.bus.emit({ type: DomainEventType.PaymentApiStatusCheckEnd, publicId, correlationId: reference, ok: false, error: { name: err?.name, message: err?.message, status: err?.status } });
    });
    return p;
  }

  pay(payment: Pay): Promise<any> {
    const p = lastValueFrom(this.client.post<any>(`${this.apiUrl}/v1/public/requests/pay`, payment));
    p.then(() => this.bus.emit({ type: DomainEventType.PaymentApiInitiateEnd, publicId: payment.publicId, correlationId: payment.transactionCorrelationId, ok: true })).catch((err: any) => {
      this.bus.emit({ type: DomainEventType.PaymentApiInitiateEnd, publicId: payment.publicId, correlationId: payment.transactionCorrelationId, ok: false, error: { name: err?.name, message: err?.message, status: err?.status } });
    });
    return p;
  }
}
